import './brand-logo.scss';

import classNames from 'classnames';

import Logo from '@/media/logo.svg?react';
import { APP_NAME } from '@/shared/constants';
import { ROUTES } from '@/shared/routes';
import { LocalizedLink } from '@/shared/ui';

interface IProps {
  /** На тёмной подложке drawer — светлый логотип. */
  inverse?: boolean;
  onClick?: () => void;
}

/** Логотип-ссылка на стартовый раздел кабинета. */
const BrandLogo: React.FC<IProps> = ({ inverse, onClick }) => {
  return (
    <LocalizedLink
      to={ROUTES.home}
      className={classNames('brand-logo', { 'brand-logo--inverse': inverse })}
      aria-label={APP_NAME}
      onClick={onClick}
    >
      <Logo className="brand-logo__image" aria-hidden="true" />
    </LocalizedLink>
  );
};

export default BrandLogo;
